export default __webpack_public_path__ + "static/B1-min-a469ba888e1c0d83d2f19882534bb9a3.pdf";